import { Routes } from '@angular/router';

export const pendingDataRoutes: Routes = [
  {
    path: 'send-downlink',
    loadComponent: () =>
      import(
        './send-downlink-lora-get-pending-data/send-downlink-lora-get-pending-data.component'
      ).then((m) => m.SendDownlinkLoraGetPendingDataComponent),
  },
];
